@if (isEmailAddress()) {
  <span class="bpi__icon-email" id="address-icon"></span>
} @else {
  <span class="mr-10">
    <img
      class="image-size"
      [src]="icon"
      (error)="img.src = '/assets/images/default-asset.svg'"
      alt="{{ 'logo_alt_text' | translate }}"
      #img />
  </span>
}
<div class="address-container mr-10">
  <span>{{ getAddressLabel() }}</span>
  <div class="text-light line-height-18 address" [class.memo]="address.destination_tag">
    <span>{{ address.getValue() }}</span>
    @if (address.destination_tag) {
      <span>/ {{ address.destination_tag }}</span>
    }
  </div>
</div>
<div class="action-buttons">
  <a class="bpi__icon-send stronger-text font-size-20" (click)="send()" (keydown.enter)="send()" [tabIndex]="0"></a>
  @if (!isMultiSignature()) {
    <a
      class="bpi__icon-clipboard stronger-text font-size-20 clipboard"
      [copyToClipboard]="address.getValue()"
      [copyInfo]="'copied_tag_to_clipboard' | translate"
    [tabIndex]="0"></a>
  } @else {
    <div
      class="bpi__icon-clipboard stronger-text font-size-20 clipboard multi"
      [tabIndex]="0"
      [class.open]="_isOpen"
      #details>
      <div class="address-details font-size-15 font-normal pb-20">
        <label class="form-label text-light">{{ "address" | translate }}</label>
        <div class="detail">
          <span [class]="icon + ' text-light address-icon'">
            <span>{{ address.getValue() }}</span>
          </span>
          <a
            class="bpi__icon-clipboard stronger-text font-size-20 clipboard"
            [copyToClipboard]="address.getValue()"
            [copyInfo]="'copied_tag_to_clipboard' | translate"
          [tabIndex]="0"></a>
        </div>
        <label class="form-label text-light mt-20">{{ "destination_tag" | translate }}</label>
        <div class="detail">
          <span class="text-light">{{ address.getDestinationTag() }}</span>
          <a
            class="bpi__icon-clipboard stronger-text font-size-20 clipboard"
            [copyToClipboard]="address.getDestinationTag()"
            [copyInfo]="'copied_tag_to_clipboard' | translate"
          [tabIndex]="0"></a>
        </div>
      </div>
    </div>
  }
</div>
